export default __webpack_public_path__ + "static/media/Venturer's Vest of Pierced Flesh.a0555eb6.jpg";